import { render, staticRenderFns } from "./crudProductsMarketplace.vue?vue&type=template&id=5874c3b8"
import script from "./crudProductsMarketplace.vue?vue&type=script&lang=js"
export * from "./crudProductsMarketplace.vue?vue&type=script&lang=js"
import style0 from "./crudProductsMarketplace.vue?vue&type=style&index=0&id=5874c3b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports